import React from 'react'


function Footer() {
    return (
        <div className='w-full h-[100px] bg-gray-300 mx-auto mt-5'>
            <div className='max-w-[1240px] mx-auto px-4 flex items-center h-full text-gray-700'>
            <p className='font-medium'>© Copyright 2004-2026 by&nbsp;<a href="https//kayrakkum.com/">Kayrakkum.com&nbsp;</a>. Все права защищены.</p>
            </div>
        </div>
    )
}

export default Footer